import { createContext, useContext } from 'react';

export const PageHeaderContext = createContext(null);

export const usePageHeaderContext = () => {
    const context = useContext(PageHeaderContext);

    if (!context) {
        throw new Error('usePageHeaderContext must be used within PageHeaderContext.Provider');
    }

    return context;
};
